import { Snackbar, CircularProgress } from '@mui/joy';
import { useTranslation } from 'react-i18next';

export type LoadingMessageProps = {
  isLoading: boolean;
};

const LoadingMessage = ({ isLoading }: LoadingMessageProps) => {
  const { t } = useTranslation();
  return (
    <Snackbar open={isLoading}>
      <>
        <CircularProgress />
        {t('common.loading')}
      </>
    </Snackbar>
  );
};

export default LoadingMessage;
